import { InterfaceInstanceFunctionCreateRequest, InterfaceInstanceFunctionReply, InterfaceInstanceFunctionsReply, InterfaceInstanceFunctionUpdateRequest } from "@/backend/express/controllers/interfaceInstanceFunctions/interfaceInstanceFunctionController";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class InterfaceFunctionController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async createInterfaceFunction(interfaceFunction: InterfaceInstanceFunctionCreateRequest): Promise<InterfaceInstanceFunctionReply> {
    return this.client.create(`/api/interface-instance-functions`, interfaceFunction);
  }

  public async deleteInterfaceFunction(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/interface-instance-functions/${id}`);
  }

  public async readInterfaceFunctionsByFunctionalInterfaceInstanceId(functionalInterfaceId: string): Promise<InterfaceInstanceFunctionsReply> {
    return this.client.read(`/api/interface-instance-functions/by-functional-interface-instance/${functionalInterfaceId}`);
  }

  public async readInterfaceFunctionsByFunctionalInterfaceId(functionalInterfaceId: string): Promise<InterfaceInstanceFunctionsReply> {
    return this.client.read(`/api/interface-instance-functions/by-functional-interface/${functionalInterfaceId}`);
  }

  public async updateInterfaceFunction(req: InterfaceInstanceFunctionUpdateRequest): Promise<InterfaceInstanceFunctionReply> {
    return this.client.update(`/api/interface-instance-functions/${req.id}`, req);
  }
}
